import React, { Fragment, useEffect, useState } from 'react'
import { Button, Modal, Space, Spin } from 'antd';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { GetUserMasterDataforQR } from '../../../slices/Common/commonSlice';
import _ from 'lodash';
import { getAllServices } from "../../../slices/Common/commonSlice";

function QRToWallet() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { user: currentUser } = useSelector((state) => state.user);
    const { token: Usertoken } = useSelector((state) => state.user);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [qrinfo, setQRInfo] = useState("");
    const [qrImg, setQRImg] = useState("");
    const [qrImgShow, setQRImgShow] = useState("");
    const [userServicesInfo, setUserServicesInfo] = useState([]);



    useEffect(() => {
        setLoading(true);
        dispatch(getAllServices({ currentUser, Usertoken }))
          .unwrap()
          .then((res) => {
            setLoading(false);
            if (res.status.type === "success") {
              let getstaticqrservice = res?.data.filter((e)=> e.display_name === "QR STATIC")
            //   console.log("getstaticqrservice[0].status :",getstaticqrservice[0].status)
              setUserServicesInfo(getstaticqrservice[0].status);
            } else {
              setUserServicesInfo([]);
            }
          })
          .catch((err) => {
            setLoading(false);
            console.error(err);
          });
      }, []);
    

    // useEffect(() => {
    //     if (!_.isEmpty(qrImg)) {
    //         const blob = base64ToBlob(qrImg);
    //         // const imageUrl = URL.createObjectURL(blob);
    //         setQRImgShow(URL.createObjectURL(blob));
    //     } else {
    //         return null;
    //     }
    // }, [qrImg]);

    useEffect(() => {
    if (qrImg) {
        setQRImgShow(`data:image/png;base64,${qrImg}`);
    }
}, [qrImg]);

    useEffect(() => {
        setLoading(true);
        dispatch(GetUserMasterDataforQR({ currentUser, Usertoken }))
            .unwrap()
            .then((res) => {
                setLoading(false);
                if (res.status.type === "success") {
                    setQRInfo(res?.data?.keyValuePairList[0].value2);
                    setQRImg(res?.data?.keyValuePairList[0]?.value1);
                } else {
                    setQRInfo([]);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error(err);
            });
    }, []);

    function base64ToBlob(base64) {
        const arr = base64.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new Blob([u8arr], { type: mime });
    }

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (<Fragment className={`${userServicesInfo ? "" : "d-none"}`}>
        <Spin  spinning={loading}>
            <div className={`${userServicesInfo ? "" : "d-none"} d-flex flex-column me-4 align-items-center`} style={{ cursor: "pointer" }} onClick={showModal} >
                {/* <i class="fa-solid fa-qrcode"></i> */}
                <i class="bi bi-qr-code" style={{ fontSize: '1.3rem' }} ></i>
                <div className="fs-bold text-black h6" style={{ fontSize: '0.7rem' }} >QR To Wallet <br /></div>
            </div>
            {/* <Button type="primary" onClick={showModal}>
                Open Modal
            </Button> */}
            <Modal
                title="QR Information"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                // onOk={handleOk}
                footer={null}
                onCancel={handleCancel}
                className='text-center'
            >
                <img src={qrImgShow} alt="converted" className='text-center'  style={{ width: "90%" }} />
                <div className='text-black fw-bold fs-4 text-center'>{qrinfo || ""}</div>
                <div className='text-warning fw-bold fs-5 text-center' >Amount should be more than Rs 100</div>
            </Modal>
        </Spin>
</Fragment>
    )
}

export default QRToWallet
